<template>
  <div @mouseleave="wpLeave">
    <div class="tag workWidthDivZp">历代书法卷</div>
    <div class="wrap">
      <div v-bind:style="stylex" @mouseover="isShow=true" @mouseleave="isShow=false">
        <div v-for="(item,index) in personListJson" :key="index">
          <ul v-show="isShow" class="personSt">
            <li class="wrapliab" :style="wsli" @mouseover="showWorks(item,$event)"
                @click="toPersonDetial(item.personName)" v-if="item.coverArea==='书法家'"
            >
              <div><img src="./_ei-header/10.png" class="imgAeiuov" :style="wsimg"></div>
              {{ item.personName }}
            </li>
          </ul>
        </div>
      </div>
      <div class="wrap-list" id="wraplistw" @mouseleave="wpLeave" v-show="personWorksIsShow?isShow=true:isShow">
        <div class="wraplistulDiv">
          <ul v-for="(workxs,key) in personWorks" :key="key">
            <li class="km-li" @click="toWorkDetail(workxs.id)"><span
                class="km-li-s"> 📗{{ workxs.worksName.substring(workxs.worksName.indexOf('《')) }}
          </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryAllAuthorsAndAuthorWorks } from '@/api/reception/works-api'
import { isFailure } from '@/eiuov-utils/axios/response'

export default {
  name: 'DropdownPluginWriter',
  props: {
    lieWidth: {
      type: Number,
      required: false
    },
    lieHeight: {
      type: Number,
      required: false
    },
    lieMarginLeft: {
      type: Number,
      required: false
    },
    lieFontSzie: {
      type: Number,
      required: false
    }
  },
  computed: {
    wsli () {
      return {
        '--wrapliab-font-size': this.lieFontSzie + 'px',
      }
    },
    wsimg () {
      return {
        '--imgAeiuov-width': this.lieWidth + 'px',
        '--imgAeiuov-height': this.lieHeight + 'px',
        '--imgAeiuov-margin-left': this.lieMarginLeft + 'px',
      }
    }
  },
  data () {
    return {
      pathName: '',
      value: [],
      personWorks: [],
      personListJson: [],
      worksList: [],
      isShow: false,
      personWorksIsShow: false,
      stylex: {
        width: 200 + 'px',
        marginLeft: -130 + 'px',
        height: 2000 + 'px'
      },
    }
  },
  mounted () {
  },
  created () {
    this.pathName = this.$route.path
    console.log(this.pathName)
    queryAllAuthorsAndAuthorWorks({}).then((res) => {
      if (isFailure(res)) return
      this.personListJson = res.data.personListJson
      console.log(this.personListJson)
    })
  },
  methods: {
    handleChange (value) {
      console.log(value)
    },
    toPersonDetial (personName) {
      this.$router.push({
        path: '/PersonDetail',
        query: { name: personName },
      })
    },
    showWorks (item, event) {
      let worksNameDiv = document.getElementById('wraplistw')
      var height = worksNameDiv.offsetHeight
      var y = event.target.offsetTop
      if (height > 400) {
        worksNameDiv.style.height = height + 300 + 'px'
      } else {
        worksNameDiv.style.height = 400 + 'px'
      }
      /* offsetTop:79 ==> top:-21*/
      worksNameDiv.style.top = y - 100 + 'px'
      if (this.pathName === '/home' || this.pathName === '/Home') {
        this.personWorks = []
      } else {
        this.personWorks = []
        this.personWorksIsShow = true
        if (item.children != null) {
          for (var i = 0; i < item.children.length; i++) {
            this.personWorks.push(item.children[i])
          }
        }
      }
    },
    wpLeave () {
      this.isShow = false
      this.personWorksIsShow = false
    },
    toWorkDetail (rowGuid) {
      this.$cookies.set('works_guid', rowGuid)
      this.$router.push({
        path: '/WorksDetail',
        query: { guid: rowGuid },
      })
    },
  }
}

</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  z-index: 999;
}

.tag {
  width: 150px;
  margin-top: -18px;
  margin-left: -70px;
  font-size: 17px;
  cursor: pointer;
}

.workWidthDivZp {
  animation: workWidthDivZp 10s linear infinite;
}

@keyframes workWidthDivZp {
  0% {
    color: black;
  }
  50% {
    color: #94070a;
  }
  100% {
    color: black;
  }
}


.wrap {
  height: 100%;
  margin: 10px auto;
  position: relative;

}

.wrap h1 {
  width: 140px;
  height: 100%;
  font-size: 22px;
}

.wrap ul {
  height: auto;
  float: left;
  width: auto;
}

.wrap ul li {
  height: 37px;
  line-height: 20px;
  margin: 1px 0;
  color: black;
}

.personSt {
  margin-left: 100px;
  animation: lix 9.2s linear infinite forwards;
  animation-play-state: paused;
}

@keyframes lix {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.wrap li:hover {
  color: #94070a;
}

.wrap h1, .wrap li {
  cursor: pointer;
  user-select: none;
  border-radius: 25px;
}

* img, span, a, div {
  user-select: none;
  -webkit-user-drag: none;
}

.imgAeiuov {
  position: absolute;
  margin-top: -3px;
}

.wrap-list {
  position: absolute;
  top: -22px;
  margin-left: 60px;
  font-size: 20px;
  cursor: pointer;
  width: 1500px;
  height: 400px;
}

.wraplistulDiv {
  margin-top: 100px;
  margin-bottom: 100px;
}

.wrap-list ul {
}

.wrap-list li {
  float: left;
  list-style: none;
  display: inline;

}

.wrap-list .km-li-s {
  padding-left: 1px;
  border-radius: 10px;
  color: black;
}

.wrap-list .km-li-s:hover {
  background-color: black;
  color: white;
}

.wrapliab {
  font-size: var(--wrapliab-font-size);
}

.imgAeiuov {
  width: var(--imgAeiuov-width);
  height: var(--imgAeiuov-height);
  margin-left: var(--imgAeiuov-margin-left);
}
</style>
